import { ProgramFeature, programAllows } from "utils";

import { ALL_FIELDS_MAP_VIEW_ROUTE, ALL_FIELDS_ROUTE, ALL_FIELDS_TABLE_VIEW_ROUTE, HISTORICAL_DATA_ROUTE } from "consts";

import { FarmResponse } from "models";

export const HOME_ROUTE = "/home";

// the profile and settings area keeps the header but not the switch
const HIDDEN_ROUTE_PREFIXES = ["/user", "/notifications", "/manage-privacy", "/banking-details", "/manage-notifications"];

// content and legal pages belong to no farm, so a switch never leaves them
const FARM_INDEPENDENT_PREFIXES = ["/page", "/privacy-policy", "/cookie-policy"];

// main pages the user may stay on after a switch, with the feature the new farm's program has to allow
const MAIN_PAGES: { path: string; feature?: ProgramFeature }[] = [
  { path: HOME_ROUTE },
  { path: ALL_FIELDS_ROUTE, feature: "fields" },
  { path: ALL_FIELDS_MAP_VIEW_ROUTE, feature: "fields" },
  { path: ALL_FIELDS_TABLE_VIEW_ROUTE, feature: "fields" },
  { path: HISTORICAL_DATA_ROUTE, feature: "fields" },
  { path: "/footprinting", feature: "footprinting" },
  { path: "/wallet", feature: "payout" },
  { path: "/scenarios-landing-page" },
  { path: "/cmc", feature: "cropMixComposer" },
  { path: "/copilot" },
];

const withoutTrailingSlash = (pathname: string) => pathname.replace(/\/+$/, "") || "/";

const isUnder = (path: string, prefixes: string[]) => prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

export const isFarmSwitchHiddenOn = (pathname: string) => isUnder(withoutTrailingSlash(pathname), HIDDEN_ROUTE_PREFIXES);

/** `null` keeps the user on the page; everything that belongs to the old farm's data goes home. */
export const getRouteAfterFarmSwitch = (pathname: string, targetFarm: Pick<FarmResponse, "carbonProgram"> | undefined): string | null => {
  const path = withoutTrailingSlash(pathname);
  if (isUnder(path, FARM_INDEPENDENT_PREFIXES)) return null;

  const page = MAIN_PAGES.find((candidate) => candidate.path === path);

  if (page && (!page.feature || programAllows(targetFarm?.carbonProgram, page.feature))) return null;
  return HOME_ROUTE;
};
